import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { AuthState } from "context/AuthContext";

const StatusButtons = ({
	handleReject,
	disableEdit,
	handleEdit,
	approved,
	handleApproval,
	editButton,
	buttonName,
	remark,
	otherAccess,
}) => {
	const apporoveColor = "#A5DD9B";
	const rejectColor = "#D37676";
	const { user } = AuthState();
	const disableEditAndApproval = user.role?.SUPPLIER_VIEWER ? true : false;
	return (
		<Stack direction="row">
			{disableEdit ? (
				approved || remark !== "" || disableEditAndApproval ? (
					""
				) : otherAccess ? (
					<Button
						color="success"
						variant="contained"
						sx={{ margin: "0 5px", backgroundColor: apporoveColor }}
						onClick={handleApproval}>
						Approve
					</Button>
				) : (
					""
				)
			) : (
				""
			)}
			{disableEdit ? (
				approved || remark !== "" || disableEditAndApproval ? (
					""
				) : otherAccess ? (
					<Button
						color="error"
						variant="contained"
						sx={{ margin: "0 5px", backgroundColor: rejectColor }}
						onClick={handleReject}>
						Reject
					</Button>
				) : (
					""
				)
			) : (
				""
			)}
			{approved ? (
				<Typography sx={{ color: "green" }} variant="h6">
					Approved
				</Typography>
			) : remark !== "" ? (
				<Typography sx={{ color: "red" }} variant="h6">
					Rejected
				</Typography>
			) : disableEdit ? (
				disableEditAndApproval ? (
					<Typography variant="h6">Pending</Typography>
				) : (
					""
				)
			) : (
				<Typography variant="h6">Pending</Typography>
			)}
			{disableEdit ? (
				""
			) : !editButton || approved ? (
				""
			) : (
				<Button variant="contained" sx={{ margin: "0 5px" }} onClick={handleEdit}>
					{buttonName}
				</Button>
			)}
		</Stack>
	);
};

export default StatusButtons;
